module.exports = __webpack_public_path__ + "static/LucasPope4-939fce019960c663cc6e6d238243ac29.webp";